import React, { useState, useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import IconReport from '../components/Icons/IconReport'
import IconUsageMonitor from '../components/Icons/IconUsageMonitor'
import DashboardCarousel from './Carousel'
import { Card, Col } from 'antd'
import IconLoggedUsers from '../components/Icons/IconLoggedUsers'
import { requireAuthentication } from '../helpers/authentication'
import { useCheckPermission } from '../hooks/Permissions'
import { useFeatureFlags } from '../hooks/FeatureFlags'
import { FUNCTIONAL_DIAGRAMS_FLAG } from '../constants/featureFlags'
import useWindowSize from '../hooks/WindowSize'

// If you change this you have to change @media(max-width: 740px)
// in _main-dashboard.scss
const THREE_ITEMS_PER_PAGE_WIDTH = 740

const ReportSubMenu = () => {
  const checkPermission = useCheckPermission()
  const { usersFeatureFlags } = useFeatureFlags()
  const [url, setUrl] = useState(null)
  const [colSize, setColSize] = useState(8)
  const { width } = useWindowSize()
  const wrapperClassNames = 'main-dashboard-button'

  useEffect(() => {
    if (width <= 740) {
      setColSize(24)
    } else if (width <= 1060) {
      setColSize(12)
    } else {
      setColSize(8)
    }
  }, [width])

  const elements = []
  if (checkPermission('page-fault-report:get')) {
    elements.push(
      <Col span={colSize} className="main-dashboard-button-wrapper">
        <Card
          id="nav-to-failure-report"
          key="nav-to-failure-report"
          className={wrapperClassNames}
          onClick={() => setUrl('/reports/fault-reports')}
          hoverable
          cover={
            <div className="main-dashboard-icon">
              <IconReport />
            </div>
          }
        >
          <div className="card-label">
            {<FormattedMessage id="faultReport.subReportLabel" />}
          </div>
        </Card>
      </Col>,
    )
  }

  // only add usage monitor for users with functional_diagrams feature flag and usage monitor permission
  if (
    usersFeatureFlags &&
    usersFeatureFlags.includes(FUNCTIONAL_DIAGRAMS_FLAG) &&
    checkPermission('page-usage-monitor:get')
  ) {
    elements.push(
      <Col span={colSize} className="main-dashboard-button-wrapper">
        <Card
          id="nav-to-usage-monitor"
          key="nav-to-usage-monitor"
          className={wrapperClassNames}
          onClick={() => setUrl('/reports/usage-monitor')}
          hoverable
          cover={
            <div className="main-dashboard-icon">
              <IconUsageMonitor />
            </div>
          }
        >
          <div className="card-label">
            {<FormattedMessage id="faultReport.subUsageLabel" />}
          </div>
        </Card>
      </Col>,
    )
    // Add Logged Users button only for oem-admin, plant-admin, and plant-admin-editor
    if (checkPermission('page-logged-users-monitor:get')) {
      elements.push(
        <Col span={colSize} className="main-dashboard-button-wrapper">
          <Card
            id="nav-to-logged-users-monitor"
            key="nav-to-logged-users-monitor"
            className={wrapperClassNames}
            onClick={() => setUrl('/reports/logged-users')}
            hoverable
            cover={
              <div className="main-dashboard-icon">
                <IconLoggedUsers />
              </div>
            }
          >
            <div className="card-label">Logged Users</div>
          </Card>
        </Col>,
      )
    }
    elements.push(
      <Col span={colSize} className="main-dashboard-button-wrapper">
        <Card
          id="nav-to-global-search-usage"
          key="nav-to-global-search-usage"
          className={wrapperClassNames}
          onClick={() => setUrl('/reports/global-search-usage')}
          hoverable
          cover={
            <div className="main-dashboard-icon">
              <IconUsageMonitor />
            </div>
          }
        >
          <div className="card-label">Global Search Usage</div>
        </Card>
      </Col>,
    )
  }

  if (url) {
    return <Redirect push to={url} />
  }

  const itemsPerPage = width <= THREE_ITEMS_PER_PAGE_WIDTH ? 3 : 6

  return <DashboardCarousel elements={elements} perPage={itemsPerPage} />
}

export default requireAuthentication(ReportSubMenu)
